import React, { useState } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import LocalTexts from '../UploadDocuments.texts.json';

import { ExampleDocumentsProps } from './ExampleDocuments.types';

import styles from './ExampleDocuments.scss';

const LocalT = new MDText(LocalTexts);

export const ExampleDocuments = ({
  actionLink = '',
  documentTitle,
  images = [],
  modalDescription = '',
  modalStyle,
  title = '',
}: ExampleDocumentsProps) => {
  const [openModal, setOpenModal] = useState(false);
  const onHrefClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.DOCUMENTS_UPLOAD_EXAMPLE_OVERLAY_OPENED(title);
    setOpenModal(true);
  };

  return (
    <>
      <Hyperlink href="#help" label={actionLink} onClick={onHrefClick} />
      {openModal && (
        <Modal centered className={styles.exampleDocumentsModal} customStyle={modalStyle} dismissModal={() => setOpenModal(false)} size="small">
          <div className={styles.stickyWrapper}>
            <h3 className={styles.title}>{`${LocalT.translate('exampleDocuments.link') + documentTitle}?`}</h3>
            {modalDescription && <p>{modalDescription}</p>}
            {images?.map((image) => (
              <section key={image.title} data-image className={styles.imageSection}>
                <h4 className={styles.imageTitle}>{image.title}</h4>
                <img alt={image.alt} className={styles.image} src={image.src} />
              </section>
            ))}
          </div>
          <div className={styles.stickyButton}>
            <Button label={LocalT.translate('exampleDocuments.button') as string} onClick={() => setOpenModal(false)} />
          </div>
        </Modal>
      )}
    </>
  );
};
